import { render } from "./WalletConfigurationPage.vue?vue&type=template&id=ed8ce8ee"
import script from "./WalletConfigurationPage.vue?vue&type=script&lang=js"
export * from "./WalletConfigurationPage.vue?vue&type=script&lang=js"

import "./WalletConfigurationPage.vue?vue&type=style&index=0&id=ed8ce8ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__